<template>
    <div class="modal fade" :class="{'is-open': open}">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
                    <h3 class="modal-title">覆核明細</h3>
                </div>
                <div class="modal-body" :class="{'section-loading': isLoading}">
                    <table class="table datatable insurance-green" v-if="dataType==1">
                        <thead>
                            <tr>
                                <th>列印日期</th>
                                <th>要保人</th>
                                <th>保單號碼</th>
                                <th>服務人員</th>
                                <th>下次<br/>應繳日</th>
                                <th>契約<br/>效力</th>
                                <th>整合<br/>地址</th>
                                <th>拜訪<br/>期限</th>
                                <th>拜訪<br/>日期</th>
                                <th>拜訪狀況<br/>問題回報</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, rid) in tableData" :key="`row-${rid}`">
                                <td>{{row.print_day}}</td>
                                <td>{{row.ceapcnm}}</td>
                                <td>{{row.ceplcno}}</td>
                                <td>{{row.clcid_nm}}</td>
                                <td>{{row.cenxpdt}}</td>
                                <td>{{row.celpscs_nm}}</td>
                                <td><a class="link text-underline" @click="$emit('submit', row)">查詢</a></td>
                                <td>{{row.last_visitday}}</td>
                                <td>{{row.update_day}}</td>
                                <td>{{row.contact_nm}}</td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table datatable insurance-green" v-if="dataType==2">
                        <thead>
                            <tr>
                                <th>列印日期</th>
                                <th>要保人</th>
                                <th>保單號碼</th>
                                <th>服務人員</th>
                                <th>下次應繳日</th>
                                <th>契約<br/>效力</th>
                                <th>整合<br/>地址</th>
                                <th>實質接觸期限</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, rid) in tableData" :key="`row-${rid}`">
                                <td>{{row.print_day}}</td>
                                <td>{{row.ceapcnm}}</td>
                                <td>{{row.ceplcno}}</td>
                                <td>{{row.clcid_nm}}</td>
                                <td>{{row.cenxpdt}}</td>
                                <td>{{row.celpscs_nm}}</td>
                                <td><a class="link text-underline" @click="$emit('submit', row)">查詢</a></td>
                                <td>{{row.last_visitday}}</td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table datatable insurance-green" v-if="dataType==3">
                        <thead>
                            <tr>
                                <th>要保人</th>
                                <th>保單數</th>
                                <th>最近投保日期</th>
                                <th>備註</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, rid) in tableData" :key="`row-${rid}`">
                                <td>{{row.ceapcnm}}</td>
                                <td>{{row.sum_ceplcno}}</td>
                                <td>{{row.ceplcdt}}</td>
                                <td>{{row.note}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// const type1 = [
//     {
//         printAt: '107/08/07',
//         client: '林文東',
//         no: '0055177940',
//         service: '陳怡君',
//         serviceNo: 'FN51333',
//         nextPayAt: '107/08/07',
//         validity: '終身險滿期',
//         address: '',
//         visitDueDate: '107/08/07',
//         visitAt: '107/08/07',
//         feedback: '遷址不明'
//     }
// ];
// const type2 = [
//     {
//         printAt: '107/08/07',
//         client: '林文東',
//         no: '0055177940',
//         service: '陳怡君',
//         serviceNo: 'FN51333',
//         nextPayAt: '107/08/07',
//         validity: '正常',
//         address: '',
//         feedback: '查無地址'
//     }
// ];
// const type3 = [
//     {
//         client: '陳奇賣',
//         insureNumbers: 1,
//         lastInsureAt: '89/03/04',
//         servicePeriod: '4.6年',
//         valuable: '中高',
//         note: ''
//     }
// ];

export default {
    name: 'CheckModal',
    props: {
        open: {
            type: Boolean,
            default: false
        },
        dataType: {
            type: Number,
            default: 1
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        detailData: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            tableData: []
        }
    },
    watch: {
        "detailData": "syncData"
    },
    methods: {
        syncData() {
            this.tableData = this.detailData
        }
    }
}
</script>

<style>

</style>
